/* eslint-disable no-unused-vars */
export enum OptionsNavbar {
  START = 1,
  FAQ = 2,
  CHAT = 3,
  NOTIFICATIONS = 4,
  PRODUCTS = 5,
  PERFIL = 6,
}
